module.exports = __webpack_public_path__ + "img/CN.ef1b4559.png";